import * as c from '../constants';
import API from '../../Api';
import Alert from 'react-s-alert';
import { onWaiting } from '../../Actions';

export const isSubmitted = (success) => ({
    type: c.CHANGE_PASSWORD,
    success
})

export const changePassword = (data) => {
    return dispatch => {
        dispatch(onWaiting(true));
        API.post('/changepassword', data, dispatch)
            .then(response => {
                dispatch(onWaiting(false));
                if(!response) return;
                const { success,message } = response;
                dispatch(isSubmitted(success));
                Alert.success(message)
            });
    }
}


// WEBPACK FOOTER //
// ./src/change-password/actions/index.js